"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: 100%;\n  margin: 0 0 15px;\n  border: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var IFrameGui = _styledComponents.default.iframe.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className
  };
})(_templateObject());

var IFrame = function IFrame(props) {
  return /*#__PURE__*/_react.default.createElement(IFrameGui, props);
};

IFrame.propTypes = {
  /** Specifies the name of an <iframe> */
  name: _propTypes.default.string,

  /** Enables an extra set of restrictions for the content in an <iframe> */
  sandbox: _propTypes.default.string,

  /** Specifies the address of the document to embed in the <iframe>
   *
   * see https://www.w3schools.com/tags/att_iframe_sandbox.asp for available values
   *
   */
  src: _propTypes.default.string,

  /** Specifies the HTML content of the page to show in the <iframe> */
  srcDoc: _propTypes.default.string,

  /** Specifies the title of the <iframe> */
  title: _propTypes.default.string.isRequired,

  /** Specifies the width of an <iframe> */
  width: _propTypes.default.string
};
IFrame.defaultProps = {
  name: null,
  sandbox: null,
  src: null,
  srcDoc: null,
  width: null
};
var _default = IFrame;
exports.default = _default;